import { apiClient } from '@/services/base'
import { useMutation, UseMutationResult } from '@tanstack/react-query'

import { ILogin2FARequest } from './interfaces/request'
import { ILogin2FAResponse } from './interfaces/response'

export const Login2FAService = async (
  request: ILogin2FARequest,
): Promise<ILogin2FAResponse> => {
  const response = await apiClient.post('api/login/login2FAAsync', request, {
    baseURL: process.env.NEXT_PUBLIC_API_BACKEND_URL,
  })

  return response?.data
}

export const useLogin2FAService = (): UseMutationResult<
  ILogin2FAResponse,
  Error,
  ILogin2FARequest
> => {
  return useMutation<ILogin2FAResponse, Error, ILogin2FARequest>({
    mutationFn: async (request) => {
      const response = await apiClient.post('api/login/login2FAAsync', request)

      return response.data
    },
  })
}

export type { ILogin2FARequest, ILogin2FAResponse }
